module.exports = __webpack_public_path__ + "img/aquagod_aquascapeart.881b823.png";